module.exports = __webpack_public_path__ + "static/media/sal-kriz.d7c73bfa.jpg";